import { ColDef, ICellRendererParams } from 'ag-grid-community';

import { formatDate } from '~/shared/utils/formatNumber';
import { OptLogVolumeActions } from '~/shared/types/api';

import VolumeIdCell from './VolumeIdCell';
import TypeCell from './TypeCell';

export const getOperationColumnDefs = ({
  sortField,
}: {
  sortField: { field: string; dir: 'desc' | 'asc' };
}): ColDef<OptLogVolumeActions>[] => [
  {
    headerName: 'Type',
    initialWidth: 87,
    minWidth: 87,
    field: 'type',
    cellRenderer: ({ data }: ICellRendererParams<OptLogVolumeActions>) =>
      data?.type ? <TypeCell type={data.type} /> : null,
  },
  {
    headerName: 'Volume ID',
    initialWidth: 97,
    minWidth: 97,
    field: 'volumeId',
    cellRenderer: ({ data }: ICellRendererParams<OptLogVolumeActions>) =>
      data?.volumeId ? <VolumeIdCell id={data.volumeId} /> : null,
    sort: sortField?.field === 'volumeId' ? sortField?.dir : null,
  },
  {
    headerName: 'Instance ID',
    initialWidth: 97,
    minWidth: 97,
    field: 'instanceId',
    sort: sortField?.field === 'instanceId' ? sortField?.dir : null,
  },

  {
    headerName: 'Previous Size',
    initialWidth: 87,
    minWidth: 87,
    field: 'originalDiskSizeGb',
    valueFormatter: ({ value }) => `${value} GiB`,
    sort: sortField?.field === 'originalDiskSizeGb' ? sortField?.dir : null,
  },
  {
    headerName: 'New Size',
    initialWidth: 87,
    minWidth: 87,
    field: 'newDiskSizeGb',
    valueFormatter: ({ value }) => `${value} GiB`,
    sort: sortField?.field === 'newDiskSizeGb' ? sortField?.dir : null,
  },
  {
    headerName: 'Date',
    initialWidth: 87,
    minWidth: 87,
    field: 'actionFinishTime',
    valueFormatter: ({ value }) => formatDate(value, true),
    sort: sortField?.field === 'actionFinishTime' ? sortField?.dir : null,
  },
];
